import { getArticleData } from '@/const/articleData';
import TopLogo from '@/component/TopLogo';

const articleData = getArticleData(true);

export default ({ html }) => (
  <>
    <TopLogo />
    <div className="news-detail-md" dangerouslySetInnerHTML={{ __html: html }} />
  </>
);

export async function getStaticPaths() {
  const paths = Object.keys(articleData).map((key) => ({ params: { article: key } }));
  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const { article } = params;
  const html = articleData[article];
  return {
    props: { html },
  };
}
